import api from './api';

export interface MitarbeiterListItem {
  id: number;
  firstName: string;
  lastName: string;
}

export const mitarbeiterService = {
  getAll: async (): Promise<MitarbeiterListItem[]> => {
    const response = await api.get('/mitarbeiter');
    return response.data;
  },
};

export default mitarbeiterService;
